// types/tab.types.ts
export interface Tab {
  label: string;
  value: string;
}

export interface TabGroupProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (value: string) => void;
}

// components/common/TabGroup.tsx
import React from "react";

export const TabGroup: React.FC<TabGroupProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="mb-2">
      <div className="flex gap-8">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            className={`py-2 px-8 ${
              activeTab === tab.value
                ? "border-b-4 border-[#F15D18] text-[16px] nunito-semibold text-[#F15D18]"
                : "text-[#A8A8A8] text-[16px] nunito-semibold"
            }`}
            onClick={() => onTabChange(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
